/**
 * Inspire-hub 2 (www.giap.pl)
 *
 * Copyright © GIAP sp.z.o.o. All rights reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Krzysztof Gregorowicz <gregorowicz.k@gmail.com>, February 2017
 */

import React from 'react';
import SzczegolyUrzedu from './SzczegolyUrzedu';
import Cmentarze from './Cmentarze';
import SzczegolyEuslugi from '../../euslugi/szczegolyEuslugi/SzczegolyEuslugi';
import ServicesLayout from '../../../components/ServicesLayout';
import DeklaracjaDostepnosci from '../../../components/DeklaracjaDostepnosci/DeklaracjaDostepnosci';
import { addVisit, fetchArms } from '../../../lib/utils';

/* eslint-disable global-require*/
export default {

  path: '/:prefix',
  children: [
    {
      path: '/',
      async action(ctx) {
        if (process.env.LOG_VISITS) {
          addVisit(ctx.params.prefix, '4');
        }
        const { store } = ctx;
        const state = await store.getState();
        return {
          component: <ServicesLayout active="district" prefix={ctx.params.prefix}><SzczegolyUrzedu user={state.user} prefix={ctx.params.prefix}/></ServicesLayout>,
          description: "Inspire Hub - Platforma do publikacji danych przestrzennych dla gmin",
        };
      },
    },
    {
      path: '/cmentarze',
      async action(ctx) {
        const { store } = ctx;
        const state = await store.getState();
        return {
          component: <ServicesLayout active="district" prefix={ctx.params.prefix} ><Cmentarze user={state.user} prefix={ctx.params.prefix} /></ServicesLayout>,
          description: "Inspire Hub - Platforma do publikacji danych przestrzennych dla gmin",
        };
      },
    },
    {
      path: '/deklaracja-dostepnosci',
      async action(ctx) {
        return {
          title: 'Deklaracja dostępności',
          component: <ServicesLayout active="district" prefix={ctx.params.prefix}>
            <DeklaracjaDostepnosci prefix={ctx.params.prefix} />
          </ServicesLayout>,
          description: 'Inspire Hub - Platforma do publikacji danych przestrzennych dla gmin',
        };
      },
    },
    {
      path: '/:eusluga',
      async action(ctx) {
        return {
          component: <ServicesLayout active="district" prefix={ctx.params.prefix}><SzczegolyEuslugi prefix={ctx.params.eusluga} /></ServicesLayout>,
          description: "Inspire Hub - Platforma do publikacji danych przestrzennych dla gmin",
        };
      },
    },
  ],
};



// WEBPACK FOOTER //
// src/routes/urzad/szczegolyUrzedu/index.js